<template lang="html">
  <div class="badge-wrapper">
    <span>{{badge.label ? badge.label : badge.value}}</span>
    <img @click="$emit('remove', badge)" src="@/assets/icons/closeBadge.png" alt="badge close icon">
  </div>
</template>

<script>
export default {
  name: 'Badge',
  props: {
    badge: {
      required: true,
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
.badge-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 1px solid #F2F2F2;
  cursor: pointer;
  background-color: white;
  transition-duration: .3s;
  box-sizing: border-box;

  span {
    margin-right: 20px;
  }
  img {
    transition-duration: .3s;
    filter: grayscale(100%);
  }
}
.badge-wrapper:hover {
  border: 1px solid #A93330;
  img {
    filter: grayscale(0%);
  }
}
</style>
